const n = "_header_1s8rn_1", e = "_wrapper_1s8rn_9", r = "_content_1s8rn_14", t = "_noDescription_1s8rn_29", o = {
  header: n,
  wrapper: e,
  content: r,
  noDescription: t
};
export {
  r as content,
  o as default,
  n as header,
  t as noDescription,
  e as wrapper
};
//# sourceMappingURL=index.es5591.js.map
